import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    maxLinesToShow?: number;
}

export const ShowMoreWrapperWithLineClamp: React.FunctionComponent<IProps> = (props) => {
    const {preventShowLess, dataGtmClick, showMoreText, showLessText, maxLinesToShow} = props;
    const [shouldShowToggleButton, setVisibilityOfToggleButton] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);
    const [showContent, setShowContent] = useState<boolean>(false);
    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    useEffect(() => {
        const textWrapper = textRef.current;

        if (textWrapper) {
            setVisibilityOfToggleButton(textWrapper.scrollHeight > textWrapper.clientHeight);
        }
    }, []);

    return (
        <>
            <TextWrapperBase ref={textRef} showContent={showContent} linesToShow={maxLinesToShow || 4}>
                {props.children}
            </TextWrapperBase>

            <ShowMoreWrapperBase
                showContent={showContent}
                className={props.className}
                hideToggleButton={(showContent && preventShowLess) || !shouldShowToggleButton}
                variant="highlight_primary"
                onClick={() => setShowContent((prevState) => !prevState)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </ShowMoreWrapperBase>
        </>
    );
};

const ShowMoreWrapperBase = styled(Button)<{showContent: boolean; hideToggleButton: boolean}>`
    overflow-anchor: ${(props) => (props.showContent ? "none" : "auto")};
    visibility: ${(props) => (props.hideToggleButton ? "hidden" : "visible")};
`;

const TextWrapperBase = styled("div")<{
    showContent: boolean;
    linesToShow?: number;
}>`
    display: -webkit-box; /* it is necessary for proper behaviour of -webkit-line-clamp */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${(props) => props.linesToShow};
    overflow: hidden;

    ${(props) =>
        props.showContent &&
        css`
            overflow: initial;
            display: block;
        `}
`;
import React, {useEffect, useRef, useState} from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {Button} from "@pg-design/button-module";
import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    preventShowLess?: boolean;
    className?: string;
    dataGtmClick?: string;
    showMoreText?: string;
    showLessText?: string;
    maxLinesToShow?: number;
}

export const ShowMoreWrapperWithLineClamp: React.FunctionComponent<IProps> = (props) => {
    const {preventShowLess, dataGtmClick, showMoreText, showLessText, maxLinesToShow} = props;
    const [shouldShowToggleButton, setVisibilityOfToggleButton] = useState(false);
    const textRef = useRef<HTMLDivElement>(null);
    const [showContent, setShowContent] = useState<boolean>(false);
    const buttonText = showContent ? (showLessText ? showLessText : "Czytaj mniej") : showMoreText ? showMoreText : "Czytaj więcej";

    useEffect(() => {
        const textWrapper = textRef.current;

        if (textWrapper) {
            setVisibilityOfToggleButton(textWrapper.scrollHeight > textWrapper.clientHeight);
        }
    }, []);

    return (
        <>
            <TextWrapperBase ref={textRef} showContent={showContent} linesToShow={maxLinesToShow || 4}>
                {props.children}
            </TextWrapperBase>

            <ShowMoreWrapperBase
                showContent={showContent}
                className={props.className}
                hideToggleButton={(showContent && preventShowLess) || !shouldShowToggleButton}
                variant="highlight_primary"
                onClick={() => setShowContent((prevState) => !prevState)}
                data-gtm-click={dataGtmClick ? dataGtmClick : ""}
            >
                <Text variant="button_micro">{buttonText}</Text>
            </ShowMoreWrapperBase>
        </>
    );
};

const ShowMoreWrapperBase = styled(Button)<{showContent: boolean; hideToggleButton: boolean}>`
    overflow-anchor: ${(props) => (props.showContent ? "none" : "auto")};
    visibility: ${(props) => (props.hideToggleButton ? "hidden" : "visible")};
`;

const TextWrapperBase = styled("div")<{
    showContent: boolean;
    linesToShow?: number;
}>`
    display: -webkit-box; /* it is necessary for proper behaviour of -webkit-line-clamp */
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${(props) => props.linesToShow};
    overflow: hidden;

    ${(props) =>
        props.showContent &&
        css`
            overflow: initial;
            display: block;
        `}
`;
